import { store } from '../redux/configure-store';
import { ScaleStatus } from '../../devices/device-enums';

export const getStableWeight = (): number => {
  const { weight, status } = store.getState().scale;
  if (status === ScaleStatus.STABLE_WEIGHT && weight > 0) {
    return weight;
  } else {
    return 0;
  }
};
export const getStatusCodeId = (): IStatusResponse => {
  const { status } = store.getState().scale;
  const errorId = 'ItemError_NoitemOnScale_Begin';

  let id = '';
  const statusMap: Partial<{ [key in ScaleStatus]: string }> = {
    WEIGHT_OVERWEIGHT: 'scale_over_weight_error',
    WEIGHT_UNDER_ZERO: 'scale_under_weight_error',
    WEIGHT_UNSTABLE: 'scale_not_stable_error',
    WEIGHT_ZERO: 'scale_no_item_on_scale',
    UNKNOWN_STATUS: 'scale_general_error',
  };

  id = statusMap[status] ?? 'scale_no_item_on_scale';
  return {
    errorMessageId: id,
    errorTitleId: status === ScaleStatus.UNKNOWN_STATUS ? 'scale_general_error_title' : errorId,
  };
};

interface IStatusResponse {
  errorMessageId: string;
  errorTitleId: string;
}
